import { Routes } from '@angular/router';
import { ELECTRON_ROUTES } from './electron.routes';
import { ONLINE_ROUTES } from './online.routes';

export const routes: Routes = [
   {
    path: '',
    canMatch: [() => {
      return navigator.userAgent.toLowerCase().includes('electron');
    }],
    children: ELECTRON_ROUTES
  },
  {
    path: '',
    children: ONLINE_ROUTES
  }
];
